module.exports = __webpack_public_path__ + "static/media/em-15.1cd05762.png";